import { render, staticRenderFns } from "./UserSignature.vue?vue&type=template&id=9992890e&scoped=true&"
import script from "./UserSignature.vue?vue&type=script&lang=js&"
export * from "./UserSignature.vue?vue&type=script&lang=js&"
import style0 from "./UserSignature.vue?vue&type=style&index=0&id=9992890e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9992890e",
  null
  
)

export default component.exports